import { LimitsRequests } from '@/services/http/limits-requests';

export default {
  namespaced: true,
  state: {
    limits: {},
    dailyLimits: {},
    limitMessage: '',
  },
  getters: {
    getLimits(state) {
      return state.limits;
    },
    getDailyLimits(state) {
      return state.dailyLimits;
    },
    getLimitMessage(state) {
      return state.limitMessage;
    },
  },
  mutations: {
    setLimits(state, payload) {
      state.limits = payload;
    },
    setDailyLimits(state, payload) {
      state.dailyLimits = payload;
    },
    resetLimits(state) {
      state.limits = {};
    },
    resetDailyLimits(state) {
      state.limits = {};
    },
    setLimitMessage(state, payload) {
      state.limitMessage = payload;
    },
  },
  actions: {
    async getLimits({ commit }) {
      const requestBody = {
        period: 'MONTHLY',
      };

      const requests = [
        await LimitsRequests.getUserLimits({ ...requestBody, orderType: 'PAYMENT' }),
        await LimitsRequests.getUserLimits({ ...requestBody, orderType: 'TOP_UP' }),
      ];

      Promise.all(requests).then((response) => {
        const [item1, item2] = response;
        const limits = {};
        limits[item1[0].data[0].orderType] = item1[0].data[0];
        limits[item2[0].data[0].orderType] = item2[0].data[0];
        Object.entries(limits).forEach(([key]) => {
          limits[key].isVisible = true;
        });
        commit('setLimits', limits);
      });
    },
    async getDailyLimits({ commit }) {
      const requestBody = {
        period: '',
      };

      const requests = [
        // await LimitsRequests.getUserLimits({ ...requestBody, orderType: 'PAYMENT' }),
        await LimitsRequests.getUserLimits({ ...requestBody, orderType: 'TOP_UP' }),
      ];

      Promise.all(requests).then((response) => {
        const [item1] = response;
        const limits = {};
        limits[item1[0].data[1].orderType] = item1[0].data.find((item) => item.period === 'DAILY');
        commit('setDailyLimits', limits);
      });
    },
    async getLimitMessage({ commit }, messageType) {
      await LimitsRequests.getLimitMessage(messageType).then(((response) => {
        commit('setLimitMessage', response[0].data);
      }));
    },
  },
};
